import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst } from 'src/app/core/_constants/app.constant';
import { MainService } from 'src/app/core/_services/main.service';
import { UploadService } from 'src/app/core/_services/upload.service';

@Component({
  selector: 'app-form-viewer',
  templateUrl: './form-viewer.component.html',
  styleUrls: ['./form-viewer.component.scss']
})
export class FormViewerComponent implements OnInit {
  obj: any = [];
  @ViewChild('formContainer') formContainer!: ElementRef;
  pdfInfo: any
  oppId: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormViewerComponent>,
    private loader: NgxUiLoaderService,
    private apiService: MainService,
    private route: ActivatedRoute,
    private upload: UploadService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.obj = this.data?.formData
    console.log(this.data)

    this.route.queryParams.subscribe((res: any) => {
      this.oppId = res?.oppId || res?.jobId
    })
  }

  downloadAsPDF() {
    this.loader.start();

    const data = {
      oppId: this.oppId,
      form_id: this.data._id
    };

    this.apiService
      .getPDF(data, API_ROUTES.OPPORTUNITY.downloadForm)
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.data?.formName || 'form'}.pdf`;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(url);

          this.loader.stop();
          this.toastr.success('Form Downloaded Successfully');
          this.dialogRef.close();
        },
        error: (err) => {
          this.loader.stop();
          this.toastr.error(err?.msg || 'An error occurred');
        }
      });
  }

  fileUrl: any;
  fileBuffer: any;
  download(formName?: string) {
    // Create a link element for downloading the file
    const downloadLink: any = document.createElement('a');
    downloadLink.href = this.fileUrl;
    downloadLink.download = formName;
    // Trigger a click event on the link to download the file
    downloadLink.click();
    this.toastr.success("Form Downloaded Successfully");
    this.loader.stop();
  }
  trackByIndex(index: number, item: any) {
    return index;
  }

  trackByIndexRadio(index: number, item: any) {
    return index;
  }

  toggleSelectionRadio(option, index) {
    this.obj[index][0].selectedOptions = []
    if (!this.obj[index][0].selectedOptions?.includes(option)) {
      this.obj[index][0].selectedOptions?.push(option)
    } else {
      this.obj[index][0].selectedOptions?.splice(option, 1)
      // selectedOptions.splice(optionIndex, 1);
    }
    console.log(this.obj)
  }

  binaryData: any = ''
  async uploadFile(e, i) {
    // alert(i)
    const file: File = e.target.files[0];
    if (e.target.files && e.target.files.length) {
      this.loader.start();
      let uploadedImage: any = await this.upload?.uploadFile(file);
      if (uploadedImage) {
        this.binaryData = uploadedImage;
        this.data.formData[i][0].value = this.binaryData

        this.loader.stop();
      }
    }
  }
  imageUrl: any;

  async fileupload(e: any, index: any) {
    const selectedFile = e;
    if (e) {
      this.loader.start();
      if ((selectedFile.type.match(/png/) == null)) {
        // this.imageInvalidMsg = APP_CONSTANT.VALIDATION.imageExt;
        // this.imageInvalid = true;
        this.loader.stop();
        return false;
      }
      const randomValue = Math.random().toString(36).substring(2, 15); // Generate a random string
      const newFileName = this.addRandomValueToFileName(selectedFile.name, randomValue);
      const newFile = new File([selectedFile], newFileName, { type: selectedFile.type });

      let uploadedImage: any = await this.upload.uploadFile(newFile);
      if (uploadedImage) {
        // this.imageUrl = uploadedImage;
        this.signature = uploadedImage
        this.data.formData[index][0].value = this.signature

        // this.imageInvalidMsg = "";
        // this.imageInvalid = false;
        this.loader.stop();
        return true;
      } else {
        this.loader.stop();
        this.toastr.error(`${AppConst.ERROR_MESSAGES.SERVER_ERROR}`)
        return false;
      }
    }
    this.loader.stop()
    return false;

  }
  addRandomValueToFileName(fileName: string, randomValue: string): string {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) {
      // No extension found, just append the random value
      return `${fileName}_${randomValue}`;
    } else {
      const name = fileName.substring(0, dotIndex);
      const extension = fileName.substring(dotIndex);
      return `${name}_${randomValue}${extension}`;
    }
  }
  toggleSelection(option, index) {
    const optionData = this.obj[index][0].selectedOptions?.indexOf(option);
    if (optionData) {
      this.obj[index][0].selectedOptions?.push(option)
    } else {
      this.obj[index][0].selectedOptions?.splice(option, 1)
    }
    console.log(this.obj)
  }

  isEdit: boolean = false;
  allowEdit() {
    this.isEdit = !this.isEdit
  }

  // editForm() {
  //   console.log('Form values:', this.data);
  //   const data =
  //   {
  //     "oppId": this.oppId,
  //     "formId": this.data?.formId,
  //     "formData": this.obj,
  //     "form_id": this.data?._id
  //   }

  //   this.loader.start();
  //   this.apiService.post(`${API_ROUTES.OPPORTUNITY.appendForm}`, data).subscribe((res: any) => {
  //     if (res) {
  //       this.loader.stop();
  //       this.toastr.success("Form Edited Successfully");
  //       this.dialogRef.close(true);
  //     }
  //   })
  // }

  @ViewChild('signaturePad') signaturePad: any;
  isSignatureNotAdded: boolean = true;
  signature: string = ''

  getSignature(ev: string) {
    this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad.ctx)
    // this.signature = ev;
  }

  isCanvasBlank(canvas: any) {
    const context = canvas;
    const pixelBuffer = new Uint32Array(
      context.getImageData(0, 0, 1440, 240).data.buffer
    );

    return (!pixelBuffer.some(color => color !== 0));
  }

  // clear(pad: NgxSignaturePadComponent) {
  //   pad.clearSignaturePad();
  //   this.isSignatureNotAdded = this.isCanvasBlank(this.signaturePad.ctx)
  //   this.signature = '';
  //   this.imageUrl = '';
  // }

  // getFile(pad: NgxSignaturePadComponent, item, index) {
  //   // this.data.formData[index][0].value = this.signature
  //   this.fileupload(pad.getSignatureFile(), index);
  // }

  getSelectColorClass(field: any): string {
    const index = field.selectedOption;

    if (
      index === undefined ||
      index === null ||
      !field.value ||
      !field.value[index]
    ) {
      return 'select-gray';
    }

    return `select-${field.value[index].color}`;
  }
  getFormGroupStyle(field: any) {
    if (!field?.isAddText) { return {}; }
    const hasHighlight = field.highlightColor && field.highlightColor !== 'transparent';
    return hasHighlight
      ? { 'background-color': field.highlightColor, 'padding': '10px', 'border-radius': '6px' }
      : {};
  }

  getAddTextStyle(field: any) {
    if (!field?.isAddText) {
      return {};
    }
    return {
      'margin-bottom': '0',
      'font-weight': field.bold ? '700' : '600',
      'color': field.color || '#334155',
      'font-size': (field.fontSize || 14) + 'px'
    };
  }
}
